import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { ForgotLinks } from '../../components/layout/Auth/ForgotLinks';
import { goToLogin } from '../../helpers/location';
import { Auth } from '../layout/Auth';
import { requestNewVerificationEmail } from '../../store/actions/user';
import { SendEmailForm } from '../../components/pages/auth/SendEmailForm';
import './ResendActivation.scss';

function ResendActivationComponent(props) {
  const { requestNewVerificationEmail } = props;

  return (
    <div className="resend-activation-page">
      <Auth title={<FormattedMessage id="app.resend_email.page_title"/>}
            lead={<FormattedMessage id="app.resend_email.page_description"/>}>
        <SendEmailForm
          request={requestNewVerificationEmail}
        />
      </Auth>
      <div className="resend-activation-page__links">
        <ForgotLinks logInLink={props.goToLogin}/>
      </div>
    </div>
  );
}

ResendActivationComponent.defaultProps = {
  goToLogin
};

const mapActionsToProps = {
  requestNewVerificationEmail
};

const ResendActivation = connect( null, mapActionsToProps )( ResendActivationComponent );

export { ResendActivation, ResendActivationComponent };
